import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsOtherNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M15.249 4.155a.076.076 0 01.029-.026.088.088 0 01.039-.008.076.076 0 01.067.035l5.816 8.24a2.583 2.583 0 004.25-.042l1.737-2.566a.655.655 0 01.542-.288H30V7h-2.271c-1.047 0-2.026.52-2.613 1.386l-1.737 2.566a.076.076 0 01-.028.028.09.09 0 01-.04.009.091.091 0 01-.04-.008.077.077 0 01-.029-.027l-5.816-8.24a2.583 2.583 0 00-4.198-.031l-2.95 4.048a.655.655 0 01-.529.27H2v2.5h7.75a3.155 3.155 0 002.549-1.298z" />
        <path d="M10.554 11.852a2.583 2.583 0 014.233-.017l5.81 8.233a.076.076 0 00.069.035.09.09 0 00.04-.008.075.075 0 00.028-.027l2.629-3.73A3.155 3.155 0 0125.942 15H30v2.5h-4.058a.655.655 0 00-.535.278l-2.63 3.73a2.583 2.583 0 01-4.222.002l-5.81-8.233a.076.076 0 00-.03-.027.088.088 0 00-.04-.008.089.089 0 00-.039.009.076.076 0 00-.028.027l-1.99 2.866A3.155 3.155 0 018.027 17.5H2V15h6.027a.655.655 0 00.537-.281z" />
        <path d="M10.604 21.202a.076.076 0 00-.029.026L7.628 25.22A3.155 3.155 0 015.09 26.5H2V24h3.09a.655.655 0 00.527-.266l2.947-3.991a2.583 2.583 0 014.189.045l5.814 8.236a.075.075 0 00.029.027c.01.005.023.008.04.008s.03-.004.04-.01a.077.077 0 00.028-.027l1.741-2.615A3.155 3.155 0 0123.071 24H30v2.5h-6.929a.655.655 0 00-.545.292l-1.741 2.616a2.583 2.583 0 01-4.26.058L10.71 21.23a.076.076 0 00-.029-.027c-.01-.005-.023-.009-.039-.009s-.03.004-.039.008z" />
      </g>
    </svg>
  )
);
SvgSportsOtherNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsOtherNormalMedium;
